<template>
    <div>
        <h2 style="margin-bottom:32px;">Welcome back, {{contactPersonName}}</h2>
          <div class="col-xs-12 col-sm-4">
                <a href="javascript:;" data-toggle="modal" data-target="#choose-pickl-type-popup"><Card icon="Dashboard/create_pickl.png" value="Build Campaign"  color="#6B8F5E" /></a>
            </div>
            <div class="col-xs-12 col-sm-4">
                <router-link to="/brand/payment-history?tab=subscription"><Card icon="Dashboard/brandpayment_icon.png" :value="'Credits: ' + dashboardContent.credits"   color="#38b2ac" /></router-link>
            </div>
            <div class="col-xs-12 col-sm-4">
                <router-link to="/brand/tutorial-videos"><Card icon="Dashboard/viewhostory_icon.png" value="Tutorials" color="#718096" /></router-link>
            </div>

        <div class="col-sm-4 col-xs-12" >
          <h3 class="dashboard-section-title">Geo-Located Activities</h3>
          <router-link to="/brand/pickl-history?status=APPROVED"><Card icon="Dashboard/newpickls_icon.png" value="Fresh Alerts"  color="#38a169" /></router-link>
          <a data-target="#export-pickl-popup"  data-toggle="modal" style="cursor: pointer;"><Card icon="Dashboard/create_pickl.png" value="Data Export"  color="#805ad5" /></a>

        </div>
        <div class="col-sm-4 col-xs-12" >
          <h3 class="dashboard-section-title">Go-Anywhere Activities</h3>
          <router-link to="/brand/non-geo-pickl-history?status=APPROVED"><Card icon="Dashboard/newpickls_icon.png" value="Fresh Alerts"  color="#38a169" /></router-link>
          <router-link to="/brand/non-geo-pickl-history?status=APPROVED"><Card icon="Dashboard/create_pickl.png" value="Data Export"  color="#805ad5" /></router-link>
        </div>
        <div class="col-sm-4 col-xs-12" >
          <h3 class="dashboard-section-title">Data Visuals</h3>
          <router-link to="/brand/insight-custom" v-if="$store.state.userData.brandId == 240"><Card icon="Dashboard/brandpayment_icon.png" value="Campaign Summary"  color="#dd6b20" /></router-link>
          <router-link to="/brand/campaigns" v-else><Card icon="Dashboard/brandpayment_icon.png" value="Campaigns"  color="#dd6b20" /></router-link>
          <router-link to="/brand/insights"><Card icon="Dashboard/viewhostory_icon.png" value=" Insights "  color="#3182ce" /></router-link>
        </div>
        <choose-pickl-type-popup :brandId="$store.state.userData.brandId" :popupId="'choose-pickl-type-popup'"/>
        <ExportPickl :popupId="'export-pickl-popup'" :brandId="brandId"/>

    </div>
</template>

<script>
import Card from '@/components/common/Card.vue'
import CreatePicklPopup from '@/components/common/CreatePicklPage.vue'
import ChoosePicklTypePopup from '@/components/common/ChoosePicklTypePopup.vue'
import ExportPickl from '@/components/common/ExportPickl.vue'

export default {
  data () {
    return {
      dashboardContent: {},
      busy: true,
      brandId: 0
    }
  },
  name: 'BrandDashboard',
  components: {
    Card,
    CreatePicklPopup,
    ChoosePicklTypePopup,
    ExportPickl
  },
  methods: {
    getBrandDashboard () {
      this.busy = true
      this.$http
        .get('brands/' + this.brandId + '/dashboard')
        .then(
          function (response) {
            this.dashboardContent = response.body.data
            this.busy = false
          },
          function (response) {
            this.errorMessage = response.body.message
            this.busy = false
          }
        )
    }
  },
  computed: {
    contactPersonName () {
      let name = this.dashboardContent.contact_person_name
      if (name) {
        let index = name.indexOf(' ')
        if (index > -1) {
          name = name.substring(0, index)
        }
      } else {
        name = 'PICKL'
      }
      return name
    }
  },
  mounted () {
    this.getBrandDashboard()
  },
  created () {
    this.brandId = this.$store.state.userData.brandId
    this.onBoarded = this.$store.state.userData.onBoarded
    console.log(this.$store.state.userData)
  }
}
</script>

<style scoped>
h2 {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 15px;
    font-weight: 600;
    color: #2d3748;
    letter-spacing: 0;
    margin-top: 0;
}

.dashboard-section-title {
    margin-bottom: 16px;
    margin-left: 15px;
    font-size: 16px;
    font-weight: 600;
    color: #4a5568;
}

@media only screen and (max-width: 575px) {
    h2 {
        font-size: 20px;
        line-height: 32px;
    }
}
div.card {
  max-width: 80%;
}
</style>
